import React from 'react';
import PropTypes from 'prop-types';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';

function ModalContainer({ modalJSX }) {
  return (
    <>{modalJSX}</>
  );
}

ModalContainer.propTypes = {
  modalJSX: PropTypes.element.isRequired,
};

export { ModalContainer };
export default connectModalContainerContextToComponent(ModalContainer);
